"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarCatalogAddExtras = void 0;
var react_redux_1 = require("react-redux");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var messageContext_1 = require("../../hoc/messageContext");
var react_2 = __importDefault(require("react"));
var icons_1 = require("@ant-design/icons");
var catalogCarSlice_1 = require("../../redux/slice/catalogCarSlice");
var form_1 = __importDefault(require("antd/es/form"));
var select_1 = __importDefault(require("antd/es/select"));
var button_1 = __importDefault(require("antd/es/button"));
var spin_1 = __importDefault(require("antd/es/spin"));
var CarCatalogAddExtras = function (props) {
    var configurations = props.configurations;
    var _a = (0, react_1.useState)(null), extraGroup = _a[0], setExtraGroup = _a[1];
    var _b = (0, react_1.useState)(null), extraNames = _b[0], setExtraNames = _b[1];
    var dispatch = (0, react_redux_1.useDispatch)();
    var id = (0, react_router_dom_1.useParams)().id;
    var _c = (0, messageContext_1.useMessageContext)(), showSuccess = _c.showSuccess, showError = _c.showError;
    var form = form_1.default.useForm()[0];
    var _d = (0, react_1.useState)(false), loading = _d[0], setLoading = _d[1];
    (0, react_1.useEffect)(function () {
        form.resetFields();
    }, [configurations]);
    (0, react_1.useEffect)(function () {
        var fetchExtraGroup = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, car_catalog_extra_groups, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        setLoading(true);
                        return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/car_catalog_extra_groups"))];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        car_catalog_extra_groups = (_a.sent()).car_catalog_extra_groups;
                        setExtraGroup(car_catalog_extra_groups);
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        console.error('Error fetching extra groups');
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        var fetchExtraNames = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, car_catalog_extra_names, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        setLoading(true);
                        return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/car_catalog_extra_names"))];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        car_catalog_extra_names = (_a.sent()).car_catalog_extra_names;
                        setExtraNames(car_catalog_extra_names);
                        return [3 /*break*/, 5];
                    case 3:
                        e_2 = _a.sent();
                        console.error('Error fetching extra names');
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchExtraGroup();
        fetchExtraNames();
    }, []);
    var handleAdd = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/car_catalog_extras"), {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                car_catalog_extra: __assign({}, values),
                            }),
                        })];
                case 2:
                    response = _a.sent();
                    if (response.ok) {
                        dispatch((0, catalogCarSlice_1.catalogCarLoader)(id));
                        showSuccess('Характеристика успешно добавлена');
                    }
                    else {
                        throw new Error('Ошибка при добавлении');
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    showError('Ошибка при добавлении характеристики');
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (react_2.default.createElement(react_2.default.Fragment, null, extraGroup && extraNames ? (react_2.default.createElement(form_1.default, { form: form, layout: "inline", onFinish: handleAdd },
        react_2.default.createElement(form_1.default.Item, { name: 'car_catalog_configuration_id' },
            react_2.default.createElement(select_1.default, { style: { backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' }, placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u044E", options: configurations.map(function (configuration) { return ({
                    label: configuration.package_name,
                    value: configuration.id,
                }); }) })),
        react_2.default.createElement(form_1.default.Item, { name: 'car_catalog_extra_group_id' },
            react_2.default.createElement(select_1.default, { showSearch: true, style: { backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' }, placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u044E", optionFilterProp: "label", options: extraGroup.map(function (group) { return ({
                    label: group.name,
                    value: group.id,
                }); }) })),
        react_2.default.createElement(form_1.default.Item, { name: 'car_catalog_extra_name_id' },
            react_2.default.createElement(select_1.default, { showSearch: true, style: { backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' }, placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u044E", optionFilterProp: "label", options: extraNames.map(function (name) { return ({
                    label: name.name,
                    value: name.id,
                }); }) })),
        react_2.default.createElement(form_1.default.Item, null,
            react_2.default.createElement(button_1.default, { type: "primary", icon: react_2.default.createElement(icons_1.PlusOutlined, null), htmlType: "submit", loading: loading }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0443")))) : (react_2.default.createElement(spin_1.default, { size: "small" }))));
};
exports.CarCatalogAddExtras = CarCatalogAddExtras;
